import type { FC } from 'react';
import React, { useCallback, useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Tabs, TabList, Tab, TabPanel } from 'ui-components/components/tabs';

import { CustomDeclaration } from '../../../../components/custom-declaration';
import { ReadOnlyDeclaration } from '../../../../components/custom-declaration/read-only-declaration';
import { CustomsContext } from '../../../../context/context';
import messages from '../../../../components/messages';
import type { CustomsItem } from '../../../../types';
import type { CustomsDeclarationsSectionType } from '..';
import styles from './styles.module.less';

export const DeclarationsTabs: FC<CustomsDeclarationsSectionType> = ({ readOnly }): JSX.Element => {
  const { customsItems } = useContext(CustomsContext);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const onRemoveDeclaration = useCallback(
    (removedIndex: number) => {
      if (removedIndex === selectedTabIndex) {
        setSelectedTabIndex((prevIndex) => Math.max(0, prevIndex - 1));
      } else if (removedIndex < selectedTabIndex) {
        setSelectedTabIndex((prevIndex) => prevIndex - 1);
      }
    },
    [selectedTabIndex],
  );

  if (customsItems.length === 0) {
    return <></>;
  }

  return (
    <Tabs onSelectedTabIndexChange={setSelectedTabIndex} selectedTabIndex={selectedTabIndex}>
      <TabList className={styles['tab-list']}>
        {customsItems.map((item: CustomsItem, index: number) => {
          const { customsItemId, declarationKey } = item;
          return (
            <Tab key={customsItemId || declarationKey}>
              <FormattedMessage {...messages.declarationHeader} values={{ declaredCount: index + 1 }} />
            </Tab>
          );
        })}
      </TabList>

      {customsItems.map((item: CustomsItem, index: number) => {
        const { customsItemId, declarationKey } = item;
        return (
          <TabPanel key={customsItemId || declarationKey}>
            {readOnly ? (
              <ReadOnlyDeclaration customItem={item} />
            ) : (
              <CustomDeclaration customItem={item} index={index} onRemoveDeclaration={onRemoveDeclaration} />
            )}
          </TabPanel>
        );
      })}
    </Tabs>
  );
};
